import { useEffect, useState, useRef } from "react";
import { fabric } from "fabric";

function useFabric({ height, width }) {
  const [canvas, setCanvas] = useState(null);
  const fabricRef = useRef(null);
  useEffect(() => {
    const fabricCanvas = new fabric.Canvas(fabricRef.current, {
      preserveObjectStacking: true,
      height,
      width,
      fireRightClick: true,
      backgroundColor: "#fff"
    });
    setCanvas(fabricCanvas);
  }, [height, width]);
  return { fabricRef, canvas };
}

export default useFabric;
